import styled, { css } from 'styled-components';

type Props = {
  offset?: string;
  flex?: string;
};

export const Container = styled.div<Props>`
  padding: ${props => props.offset}px 0;
  ${props =>
    props.flex &&
    css`
      display: flex;
      justify-content: center;
      > div {
        padding-right: 15px;
        &:last-child {
          padding-right: 0;
        }
      }
    `}
  a {
    color: #ff6969;
  }
`;
